const utils = require('../../../lib/utils')
const ClientError = require('../../../client/error')

module.exports = {
	model: {
		fieldConfigHasBeenInitialized: false, // has config been initialized?

		dirtyAssignedTags: {},
		dirtySubFields: {},
		// preparedTags: {}, // TODO: POIA
		// preparedAssignedTags: { // used by utils.fields.prepareTagPicker to store a flat list of assigned tags by tagKey in the following format:
		// 	/*
		// 	[<categoryID>_<categoryDataID>]: {
		//
		// 	}
		// 	*/
		// },

		onDecisionCallback: null, // stores the onDecision-callback which may be given as a parameter of decisionOptions.
		openActionName: null, // name of the action used to open the tagAssignment-modal.

		config: {
			// DATA
			dataFormat: '', // table, array
			// tagScope: 'routes', // tagScope to show in tagAssignment
			// relationConfig: { // where to find assigned tags within the data in case of dataFormat === 'table'?
			// 	subFormAlias: 'cms_entities_categories',
			// 	subFormAliasContainer: 'children'
			// },
			// categoryEntityType: 'routes', // which entityType should be used in case of dataFormat === 'table'?

			// GUI
			showSummary: true, // should summary be shown
			showSummaryFullPaths: false, // should elements show their full paths within summary
			isHidden: false, // hide this tag-picker-button from a user?
			supportDeleteSelection: false, // show inline button to delete all assignments?

			// TAG ASSIGNMENT
			supportCollapsibleTags: false, // should tagAssignment support collapsible tags?
			// maxOpenLevelOnInit: 1, // in case supportCollapsibleTags is true this tells about the depth level until elements get collapsed on open.
			selectParentsGranted: true, // sometimes only leafs should be selectable.
			useNormalDirtyColor: false, // sometimes the tagAssignment should be kept neutral in styles.

			// DEPRECATED
			// relationsMappedBySimpleArray: false, // deprecated. use dataFormat = 'array' instead
		}
	},

	events: {
		open: {
			type: 'click',
			action: function(event) {
				event.preventDefault()
				event.stopImmediatePropagation()

				const self = event.data.component
				const $target = $(event.target)
				const $realTarget = $target.closest('button')

				if($realTarget.length > 0) {
					const mode = $realTarget.data('buttonMode')
					if(mode === 'empty'){
						self.emptyAssignedTags()
					} else {
						const $potentialParentModal = $target.closest('.base_modal_modal')
						const overruleCKEditor = ($potentialParentModal.length > 0 && $potentialParentModal.hasClass('overruleCKEditor'))

						self.open(undefined, undefined, undefined, undefined, overruleCKEditor)
					}
				}
			}
		}
	},

	methods: {
		sanitizeResources(storage){
			this.initModel(storage)
		},

		initFieldConfig(){
			if(this.model.fieldConfigHasBeenInitialized){
				return
			}
			this.model.fieldConfigHasBeenInitialized = true

			const fieldConfig = this.model.config || {}
			const relationConfig = fieldConfig.relationConfig || {}

			// init fieldConfig if necessary
			if(!fieldConfig.dataFormat){
				// TODO: remove relationsMappedBySimpleArray after downwards compatibility is not needed any longer!
				if(fieldConfig.categoryEntityType && fieldConfig.relationsMappedBySimpleArray !== true){
					fieldConfig.dataFormat = 'table'
				} else {
					fieldConfig.dataFormat = 'array'
				}
			}

			if(fieldConfig.dataFormat === 'table'){
				if(!fieldConfig.categoryEntityType){
					throw new ClientError('MISSING_CATEGORY_ENTITY_TYPE')
				}

				relationConfig.subFormAlias = relationConfig.subFormAlias || 'cms_entities_categories'
				relationConfig.subFormAliasContainer = relationConfig.subFormAliasContainer || 'children'
			} else if(fieldConfig.dataFormat === 'array'){
				if(fieldConfig.categoryEntityType){
					console.error(`array-tagPicker with categoryEntityType: ${fieldConfig.categoryEntityType} found. maybe one intended to use this tagPicker in combination with cms_entities_categories?`)
				}
			}

			if(fieldConfig.showSummary === undefined){
				fieldConfig.showSummary = true
			}
		},

		initModel: function(storage){
			storage = storage || globalThis.storage
			this.initFieldConfig()

			const fieldConfig = this.model.config || {}
			const relationConfig = fieldConfig.relationConfig || {}

			this.model.turnedOffTagCategoryManagement = storage && storage.user ? storage.user.hasAccessTo('usage:turnedOffTagCategoryManagement', this.scope) : false
			this.model.preparedAssignedCategories = {}
			this.closest('base_form_form', formComponent => {
				let assignedTags, primaryKey, resourceData, inheritedCategories, modelKey, isDirty, fieldData
				let prepareSummary = false

				// use different data formats and resources according to the source (live- or dirty-data).
				// e.g., dirty data may be of interest in cases of refreshes.
				for(const resource of [{
					resourceData: (formComponent.resourceData || {}).data,
					isDirty: false,
					modelKey: 'assignedTags',
				},{
					resourceData: ((formComponent.model || {}).dirtyFields || {}).data,
					isDirty: true,
					modelKey: 'dirtyAssignedTags',
				}]){

					// identify data to use
					resourceData = resource.resourceData || {}
					modelKey = resource.modelKey
					isDirty = resource.isDirty
					if(isDirty){
						fieldData = formComponent.getFieldValue(this.model.fieldCode, 'dirty')
					} else {
						fieldData = formComponent.getFieldValue(this.model.fieldCode, 'live')
					}

					// prepare inheritedCategories if necessary
					if(!isDirty){
						if(
							(primaryKey = (resourceData.attributes || {})[resourceData.primaryKey || 0] || 0) &&
							(inheritedCategories = (this.model['tag-picker-data'] || {}).inheritedCategories || {}) &&
							inheritedCategories[primaryKey]
						){
							this.model.inheritedCategories = inheritedCategories[primaryKey]
						} else {
							this.model.inheritedCategories = {}
						}
					}

					// translate mapping in case of array format
					if(fieldConfig.dataFormat === 'array'){
						this.model[modelKey] = []
						let tagParts
						for(const tag of fieldData || []){
							tagParts = String(tag || '').split('_')
							if(tagParts.length === 2){
								// dirty data does not support an attributes-key.
								if(isDirty){
									this.model[modelKey].push({
										categoryID: 	tagParts[0] * 1,
										categoryDataID: tagParts[1] * 1
									})
								} else {
									this.model[modelKey].push({
										attributes: {
											categoryID: 	tagParts[0] * 1,
											categoryDataID: tagParts[1] * 1
										}
									})
								}
							}
						}

						if(this.model[modelKey].length > 0){
							prepareSummary = true
						}
					}
					// default handling for table format
					else if (
						fieldConfig.dataFormat === 'table' &&
						(assignedTags = ((resourceData[relationConfig.subFormAliasContainer] || {})[relationConfig.subFormAlias] || {}).data || []).length > 0
					){
						// get rid of attributes-key if necessary
						if(isDirty){
							this.model[modelKey] = {}
							for(const assignedTag of Object.values(assignedTags)){
								const attributes = assignedTag.attributes || {}
								this.model[modelKey][`${attributes.categoryID}_${attributes.categoryDataID}`] = attributes
							}
						} else {
							this.model[modelKey] = assignedTags

							// prepare assignedCategories if necessary
							if(fieldConfig.tagScope === 'routes'){
								utils.prepareCategories(this.model.preparedAssignedCategories, assignedTags, storage, this.model.inheritedCategories, this.scope, true)
							}
						}

						prepareSummary = true
					}
				}

				// prepare summary if necessary
				if(prepareSummary){
					this.prepareSummary()
				}
			})
		},

		prepareSummary: function(){
			const fieldConfig = this.model.config || {}
			if(!fieldConfig.showSummary) {
				return
			}

			// TODO: use utils.tags.<generators>

			const options = (this.model['tag-picker-data'] || {}).options || []
			const optionalCategories = fieldConfig.tagScope === 'routes'
			let aT, c, cD, categoryIndex, category, preparedCategory, categoryDataIndex, categoryData, assignedTagData, assignedTagAttributes, dirtyTagID
			let showHiddenCategory

			this.model.summaryOfAssignedCategories = {}
			const summaryOfAssignedCategories = this.model.summaryOfAssignedCategories

			for(c in options || []) {
				category = options[c]
				categoryIndex = ((category.resources || {}).sort || 0) + '-' + category.id
				preparedCategory = (this.model.preparedAssignedCategories || {})[category.id] || {}

				// check if optionalCategories is turned off by atom-config or if the category has been selected.
				if(!optionalCategories || (!preparedCategory.turnedOff && (!preparedCategory.turnedOffByInheritance || preparedCategory.turnedOn)) || this.model.turnedOffTagCategoryManagement){
					showHiddenCategory = optionalCategories && (preparedCategory.turnedOff || (preparedCategory.turnedOffByInheritance && !preparedCategory.turnedOn)) && this.model.turnedOffTagCategoryManagement

					// check if category is assigned
					for(aT in this.model.assignedTags || []) {
						assignedTagAttributes = (this.model.assignedTags[aT] || {}).attributes || {}
						if(!summaryOfAssignedCategories[categoryIndex] && assignedTagAttributes.categoryID === category.id){
							summaryOfAssignedCategories[categoryIndex] = {
								name: 				category.name,
								showHiddenCategory: showHiddenCategory,
								children: 			{}
							}
							break
						}
					}

					// check if category is assigned dirty
					for(dirtyTagID in this.model.dirtyAssignedTags || []) {
						assignedTagAttributes = this.model.dirtyAssignedTags[dirtyTagID] || {}
						// support data format including as well as excluding attributes-key
						assignedTagAttributes = assignedTagAttributes.attributes || assignedTagAttributes
						if(assignedTagAttributes.categoryID === category.id){
							showHiddenCategory = (
								optionalCategories &&
								this.model.turnedOffTagCategoryManagement &&
								(
									(assignedTagAttributes.type === 'delete' && preparedCategory.turnedOffByInheritance)
									||
									(assignedTagAttributes.type !== 'delete' && !Boolean(assignedTagAttributes.enabled))
								)
							)
							summaryOfAssignedCategories[categoryIndex] = {
								name: 				category.name,
								showHiddenCategory: showHiddenCategory,
								children: 			{}
							}
							break
						}
					}

					if(summaryOfAssignedCategories[categoryIndex]){
						for(cD in category.children || []) {
							categoryData = category.children[cD]
							categoryDataIndex = ((categoryData.resources || {}).sort || 0) + '-' + categoryData.id

							// check if categoryData is assigned
							for(aT in this.model.assignedTags || []) {
								assignedTagData = this.model.assignedTags[aT] || {}
								assignedTagAttributes = assignedTagData.attributes || {}
								if(!summaryOfAssignedCategories[categoryIndex].children[categoryDataIndex] && assignedTagAttributes.categoryID === category.id && assignedTagAttributes.categoryDataID === categoryData.id){
									summaryOfAssignedCategories[categoryIndex].children[categoryDataIndex] = {
										name: 	categoryData.name,
										names: 	categoryData.names,
										type: 	assignedTagData.type || 'exists', // assignedTagData may represent a protocolAction and therefor have another type than 'exists' although it is rendered as if it was a specific state of this tag-picker.
									}
									break
								}
							}

							// check if category is assigned dirty
							for(dirtyTagID in this.model.dirtyAssignedTags || []) {
								assignedTagAttributes = this.model.dirtyAssignedTags[dirtyTagID] || {}
								// support data format including as well as excluding attributes-key
								assignedTagAttributes = assignedTagAttributes.attributes || assignedTagAttributes
								if(assignedTagAttributes.categoryID === category.id && assignedTagAttributes.categoryDataID === categoryData.id){
									summaryOfAssignedCategories[categoryIndex].children[categoryDataIndex] = {
										name: 	categoryData.name,
										names: 	categoryData.names,
										type: 	assignedTagAttributes.type || (summaryOfAssignedCategories[categoryIndex].children[categoryDataIndex] || {}).type || 'create'
									}
									break
								}
							}
						}
					}
				}
			}
		},

		open: function(previouslyAssinedTags, onDecisionCallback, overrideAction, enhancedResourceRegisterContent, overruleCKEditor = false){
			const fieldConfig = this.model.config || {}

			this.model.onDecisionCallback 	= onDecisionCallback
			const actionName 		= overrideAction || 'showTagAssignment'
			const actionID 			= this.model.openActionName = actionName + '_inEffect'

			this.performAndStoreAction(
				actionID,
				this.prepareAction(
					actionName,
					undefined,
					{
						tagPickerButtonStorage: {
							onDecisionCallback: onDecisionCallback
						},
						tags: {
							options: 					(this.model['tag-picker-data'] || {}).options || [],
							inheritedCategories: 		this.model.inheritedCategories || {},
							assignedTags: 				this.model.assignedTags || previouslyAssinedTags || [],
							preparedAssignedCategories: this.model.preparedAssignedCategories || {},
							dirtyAssignedTags: 			this.model.dirtyAssignedTags,
							optionalCategories: 		fieldConfig.tagScope === 'routes',
							useNormalDirtyColor: 		fieldConfig.useNormalDirtyColor === true,
							supportCollapsibleTags: 	fieldConfig.supportCollapsibleTags === true,
							maxOpenLevelOnInit: 		fieldConfig.maxOpenLevelOnInit || 1,
							selectParentsGranted: 		fieldConfig.selectParentsGranted !== false,
						},
						enhanced: enhancedResourceRegisterContent || {}
					}, {
						source: {
							load: {
								componentData: {
									config: {
										overruleCKEditor: overruleCKEditor
									}
								}
							}
						}
					}
				),
				true
			)
		},

		// prevent the tag-picker-modal from being reopened before refreshes are necessary. e.g., summary update necessary after assignment.
		async close(){
			await this.destroyAction(this.model.openActionName)
		},

		emptyAssignedTags: function(){
			const fieldConfig = this.model.config || {}
			let lastChildChangedOptions

			if(fieldConfig.dataFormat === 'array'){
				this.model.assignedTags = []
				this.model.dirtyAssignedTags = {}
				this.triggerClosest('onChildChanged', {
					fieldCode: this.model.fieldCode,
					value: []
				})
			} else if(fieldConfig.dataFormat === 'table'){

				// remove dirty relationship entries if necessary
				utils.forEachReverse(this.model.dirtyAssignedTags, tag => {
					if(tag){
						const tagKey = `${tag.categoryID}_${tag.categoryDataID}`
						if(tag.type !== 'delete'){
							delete this.model.dirtyAssignedTags[tagKey]
						}
						this.triggerClosest('onChildChanged', (lastChildChangedOptions = {
							isRelation: true,
							value: {
								attributes: {}
							},
							fieldCode: this.model.fieldCode,
							relationConfig: fieldConfig.relationConfig,
							type: tag.type,
							relationDataIndex: tag.relationDataIndex
						}))
					}
				})

				// remove relationship entries if necessary
				utils.forEachReverse(this.model.assignedTags, (tagData, tagRelationDataIndex)=> {
					const tag = (tagData || {}).attributes || {}
					if(tag){
						const tagKey = `${tag.categoryID}_${tag.categoryDataID}`
						this.model.dirtyAssignedTags[tagKey] = {
							...tag,
							type: 'delete',
							relationDataIndex: tagRelationDataIndex
						}
						this.triggerClosest('onChildChanged', (lastChildChangedOptions = {
							isRelation: true,
							value: {
								attributes: tag
							},
							fieldCode: this.model.fieldCode,
							relationConfig: fieldConfig.relationConfig,
							type: 'delete',
							relationDataIndex: tagRelationDataIndex
						}))
					}
				})

				if(lastChildChangedOptions){
					lastChildChangedOptions.isLastRelationElement = true
					this.triggerClosest('onChildChanged', lastChildChangedOptions)
				}
			}

			this.prepareSummary()
			this.refresh(false)
		},

		tagToggle: function(categoryID, categoryDataID){
			const tagKey = `${categoryID}_${categoryDataID}`

			if(this.model.dirtyAssignedTags[tagKey]){
				delete this.model.dirtyAssignedTags[tagKey]
			} else {
				this.model.dirtyAssignedTags[tagKey] = {
					type: 'create',
					categoryID: categoryID * 1,
					categoryDataID: categoryDataID * 1,
					enabled: null
				}
			}

			this.trigger('onDecision', {
				decisionOptions: {
					decisionType: 'decisionComponent',
					dirtyAssignedTags: this.model.dirtyAssignedTags
				}
			})
		}
	},

	hooks: {
		async onDecision($element, options){
			const fieldConfig = this.model.config || {}
			let onDecisionCallback = this.model.onDecisionCallback

			if(!onDecisionCallback){
				for(const action of Object.values(this.actions)){
					if(action.ready){
						onDecisionCallback = ((action.resourceRegister || {}).tagPickerButtonStorage || {}).onDecisionCallback
						break
					}
				}
			}

			if(utils.isFunction(onDecisionCallback)){
				options.categoryEntityType = fieldConfig.categoryEntityType
				await onDecisionCallback(options)
			}
			// should this decision be translated into a field change, or ...
			else if(options && options.decisionOptions && options.decisionOptions.dirtyAssignedTags){

				let lastChildChangedOptions

				// save dirtyAssignedTags in case of reopen tagAssignment
				const lastDirtyAssignedTags = utils.simpleCopy(this.model.dirtyAssignedTags)
				this.model.dirtyAssignedTags = options.decisionOptions.dirtyAssignedTags || {}

				if(fieldConfig.dataFormat === 'array'){
					if(!this.model.originalDataJSON){
						if(this.model.dataJSON){
							this.model.originalDataJSON = utils.simpleCopy(this.model.dataJSON)
						}
						else {
							this.model.originalDataJSON = []
						}
					}
					const newValue = utils.simpleCopy(this.model.originalDataJSON)
					const dirtyValues = this.model.dirtyAssignedTags || {}
					let d, i
					for(d in dirtyValues){
						i = newValue.indexOf(d)
						if(i > -1){
							newValue.splice(i, 1)
						}
						if(dirtyValues[d].type === 'create'){
							newValue.push(d)
						}
					}

					await this.triggerClosest('onChildChanged', {
						value: 		newValue.sort(),
						fieldCode: 	this.model.fieldCode
					})
				} else if(fieldConfig.dataFormat === 'table') {
					// remove relationship entries if necessary
					let lastDirtyTag
					for(const { key: dirtyTagID } of utils.eachReverse(lastDirtyAssignedTags)){
						if(!this.model.dirtyAssignedTags[dirtyTagID]){
							lastDirtyTag = lastDirtyAssignedTags[dirtyTagID]
							await this.triggerClosest('onChildChanged', (lastChildChangedOptions = {
								isRelation: true,
								value: {
									attributes: {}
								},
								fieldCode: this.model.fieldCode,
								relationConfig: fieldConfig.relationConfig,
								type: lastDirtyTag.type,
								relationDataIndex: lastDirtyTag.relationDataIndex
							}))
						}
					}

					// tell parent form about all dirty tagAssignments
					let relationAttributes
					for(const dirtyTag of Object.values(options.decisionOptions.dirtyAssignedTags || {})){
						relationAttributes = {
							entityType: fieldConfig.categoryEntityType,
							categoryID: dirtyTag.categoryID,
							categoryDataID: dirtyTag.categoryDataID
						}
						if (dirtyTag.categoryDataID === null) {
							relationAttributes.enabled = dirtyTag.enabled
						}
						relationAttributes[dirtyTag.primaryKey || 'id'] = dirtyTag.id
						await this.triggerClosest('onChildChanged', (lastChildChangedOptions = {
							isRelation: true,
							value: {
								attributes: relationAttributes
							},
							fieldCode: this.model.fieldCode,
							relationConfig: fieldConfig.relationConfig,
							type: dirtyTag.type,
							relationDataIndex: dirtyTag.relationDataIndex
						}))
					}

					// trigger one extra in case its necessary to react exactly once the change are done
					if(lastChildChangedOptions){
						lastChildChangedOptions.isLastRelationElement = true
						await this.triggerClosest('onChildChanged', lastChildChangedOptions)
					}
				}

				await this.prepareSummary()
				await this.close()
				await this.refresh(false)
			}
			// ... should the trigger be handed over to the next onDecision handler.
			else {
				await this.triggerClosest('onDecision', options)
			}
		},

		onChildChanged: function($element, options){
			// remember dirty subFields (e.g., <fieldCode>_tagConnection) for refreshes.
			this.model.dirtySubFields = this.model.dirtySubFields || {}
			this.model.dirtySubFields[options.fieldCode] = options.value

			this.parent(function(parentComponent){
				parentComponent.triggerWhenReady('onChildChanged', options)
			})
		}
	},

	handlers: [
		{
			name: 'afterTagsUpdate',
			componentClass: '',
			handle: function(){
				this.refresh(true, undefined, undefined, undefined, () => {
					// init model after refresh (e.g., used for summary and other prerequisites)
					this.initModel()
					let actionKey, tagResourceRegister, containerComponent
					for(actionKey in this.actions){
						if(
							this.actions[actionKey].ready &&
							(tagResourceRegister = (this.actions[actionKey].resourceRegister || {}).tags) &&
							(containerComponent = ((this.actions[actionKey].source || {}).load || {}).component)

						){
							tagResourceRegister.options = utils.simpleCopy((this.model['tag-picker-data'] || {}).options || [])
							containerComponent.find('base_tags_tagAssignment', tagAssignment => {
								tagAssignment.resourceData.options = tagResourceRegister.options
							})
						}
					}
				})
			}
		}
	]
}
